/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appGithub_viewer$ref = any;
export type appGithub_QueryVariables = {||};
export type appGithub_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appGithub_viewer$ref,
  |}
|};
export type appGithub_Query = {|
  variables: appGithub_QueryVariables,
  response: appGithub_QueryResponse,
|};
*/


/*
query appGithub_Query {
  viewer {
    actualPersonId
    component(name: "app_github")
    ...appGithub_viewer
    id
  }
}

fragment appGithub_viewer on Viewer {
  id
  company {
    id
    githubEnabled
    githubInstallationId
    githubUnauthorizedInstallation
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_github"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_github\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appGithub_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appGithub_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appGithub_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubInstallationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubUnauthorizedInstallation",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appGithub_Query",
    "operationKind": "query",
    "text": "query appGithub_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_github\")\n    ...appGithub_viewer\n    id\n  }\n}\n\nfragment appGithub_viewer on Viewer {\n  id\n  company {\n    id\n    githubEnabled\n    githubInstallationId\n    githubUnauthorizedInstallation\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '640e17c9a5499ad900fd502b4183baa1';

module.exports = node;
